<template>
  <div class="card mb-0">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="profile-view">
            <div class="profile-img-wrap">
              <div class="profile-img">
                <a href="javascript:;"><img :src="getImage(data.profile_image_path)" alt="User Image"
                    v-if="data.profile_image_path" /> <img src="../../../../../assets/img/avatar/avatar-29.png"
                    alt="User Image" v-else /></a>
              </div>
            </div>
            <div class="profile-basic">
              <div class="row">
                <div class="col-md-5">
                  <div class="profile-info-left">
                    <h3 class="user-name m-t-0 mb-0">{{ data.first_name }} {{ data.last_name }}</h3>
                    <div class="staff-id mt-1">Employee ID : {{ data.employee_code }}</div>
                    <h6 class="text-muted mt-1">Role: {{ roleName }}</h6>
                    <h6 class="doj text-muted mt-1">Date of Joining : {{ formatDateTimeStandardShort(joiningDate) }}</h6>
                    <h6 class="small text-muted mt-1">Account type: {{ data.account_type }}</h6>

                    <!-- <div class="staff-msg">
                      <router-link class="btn btn-custom" to="/apps/chat"
                        >Send Message</router-link
                      >
                    </div> -->
                  </div>
                </div>
                <div class="col-md-7">
                  <ul class="personal-info">
                    <li>
                      <div class="title">locations:</div>
                      <div class="text" v-for="(location, index) in data.locations" :key="location.name"> {{
                        location.name }}<span v-if="index > 0">,</span></div>
                    </li>
                    <li>
                      <div class="title">Auto Checkout:</div>
                      <div class="text">{{ data.is_auto_checkout_enabled ? "Yes" : "No" }}</div>
                    </li>
                    <li>
                      <div class="title">Email:</div>
                      <div class="text">{{ data.email }}</div>
                    </li>
                    <li v-if="data.manager_id">
                      <div class="title">Reports to:</div>
                      <div class="text">
                        <!-- <div class="avatar-box">
                          <div class="avatar avatar-xs">
                            <img :src="getImage(data.profile_image_path)" alt="User Image"
                 v-if="data.profile_image_path"/>
                  <img src="../../../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else/>
                          </div>
                        </div> -->
                        <p> {{ managerName }} </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- <div class="pro-edit">
              <a
                data-bs-target="#profile_info"
                data-bs-toggle="modal"
                class="edit-icon"
                href="javascript:;"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </div> -->
          </div>
        </div>
      </div>
      <div class="text-end dropdown-container">
        <div class="dropdown dropdown-action">
          <a href="javascript:;"
            class="action-icon dropdown-toggle d-flex justify-content-center align-items-center p-1 bg-light rounded-2"
            data-bs-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_employee"
              @click="editClicked(data)"><i class="fa-solid fa-pencil m-r-5"></i> Edit</a>
            <a class="dropdown-item" href="javascript:;" @click="leavesClicked(data)"><i
                class="fa-solid fa-arrow-left m-r-5"></i> Leaves</a>
            <a class="dropdown-item" href="javascript:;" @click="attendanceClicked(data)"><i
                class="fa fa-calendar m-r-5"></i> Attendance</a>
            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#sick_leave"
              @click="sickLeaveClicked(data)"><i class="fa fa-right-from-bracket m-r-5"></i>Sick Leave</a>
            <a class="dropdown-item" href="javascript:;" @click="monitorClicked(data)"><i
                class="fa fa-street-view m-r-5"></i>{{ data.is_monitored ? 'Monitored' : 'Monitor' }}</a>
            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#face_template"
              @click="addFaceTemplateClicked(data)"><i class="fa-solid fa-plus m-r-5"></i>Add Face Template</a>
            <router-link class="dropdown-item" :to="{ name: 'employeeReport', params: { id: data.id } }"><i
                class="fa fa-th m-r-5"></i>Employee Report</router-link>
            <!-- <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_employee"><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-7">
    <div class="col-lg-12">
      <div class="table-responsive">
        <h4 class="pb-2">Attendance Details</h4>
        <table class="table table-striped custom-table mb-0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Work Hours</th>
              <th>Break Taken</th>
              <th>Edited</th>
              <th>Reason</th>
              <th>Updated By</th>
              <th>Updated At</th>
              <th v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'">Action</th>
            </tr>
          </thead>
          <tbody v-if="attendanceEmployee">
            <tr v-for="item in visibleItems" :key="item.id">
              <td>{{ formatDDMMYYYY(item.record_date) }}</td>
              <td>{{ item.first_check_in_time ? timeFormat(item.first_check_in_time) : '--' }}</td>
              <td>{{ item.last_check_out_time ? timeFormat(item.last_check_out_time) : '--' }}</td>
              <td>{{ roundOfInHour(Number(item.total_minutes) - Number(item.break_minutes)) }}</td>
              <td>{{ roundOfInHour(item.break_minutes) }}</td>
              <td>{{ item.is_manually_edited ? 'Yes' : 'No' }}</td>
              <td>{{ item.reason ? item.reason : '--' }}</td>
              <td>{{ item.updated_by_user ? (item.updated_by_user.first_name + ' ' + item.updated_by_user.last_name) : (item.updated_by && item.updated_by.first_name ? (item.updated_by.first_name + ' ' + item.updated_by.last_name) : (item.updated_by ? item.updated_by : '--')) }}</td>
              <td>{{ item.is_manually_edited && item.updated_at ? formatDateTimeStandardWithTime(item.updated_at) : '--' }}</td>
              <!-- <td>{{ item }}</td> -->
              <td href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_attendance"
                @click="editAttendanceClicked(item)"><i class="fa-solid fa-pen ms-5"
                  v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="12">
                <div class="card text-center">
                  <div class="card-body">
                    <!-- <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img"> -->
                    <p>No data have been added.</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-lg-12 text-right">
          <button v-if="hasMoreItems" @click="showMore" class="text-sm p-1">{{ visibleRowCount > 5 ? "Hide More" :
            "View More" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive mt-2">
    <h4 class="pb-2">Leaves Details</h4>
    <a-table class="stripped table-hover" :columns="columns" :data-source="visibleLeaveItems" :pagination="false">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'leave_master_category_id'">
          <h6 class="table-avatar">

            {{ getCategoriesName(record.leave_master_category_id) }}
          </h6>
        </template>
        <template v-if="column.key === 'Status'">
          <div class="text-center">
            <div class="action-label">
              <a class="btn btn-white btn-sm btn-rounded" href="javascript:void(0);">
                <i :class="record.class"></i>
                {{ record.status }}
              </a>
            </div>
          </div>
        </template>
        <template v-if="column.key === 'Approvedby'">
          <h2 class="table-avatar">
            <!-- <router-link to="/profile/employee-profile">
              <img :src="require(`@/assets/img/profiles/${record.Image}`)" alt="User Image" />
            </router-link> -->
            <a href="javascript:;">{{ record.status_updated_by }}</a>
          </h2>
        </template>
        <template v-if="column.key === 'action' && showActionButton">
          <div class="text-end">
            <div class="dropdown dropdown-action">
              <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                aria-expanded="false"><i class="material-icons">more_vert</i></a>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_leave"
                  @click="editLeavesClicked(record)"><i class="fa-solid fa-pencil m-r-5"></i> Update Status</a>
                <a v-if="isSicknessCategory(record.leave_master_category_id)" class="dropdown-item" href="javascript:;"
                  data-bs-toggle="modal" data-bs-target="#sick_leave_details_modal" @click="view(record, data.name)"><i
                    class="fa-solid fa-eye m-r-5"></i>View Details</a>
                <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_approve"
                  @click="deleteClicked(record.id)"><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
              </div>
            </div>
          </div>
        </template>
      </template>
    </a-table>
    <div class="col-lg-12 text-right">
      <button v-if="hasMoreLeaveItems" @click="showMore" class="text-sm p-1">{{ visibleRowCount > 5 ? "Hide More" :
        "View More" }}
      </button>
    </div>
  </div>

  <edit-attendance-modal ref="editAttendance"></edit-attendance-modal>
  <employee-modal @userAdded="getUserData"></employee-modal>
  <edit-employee-modal ref="editEmployee" @editedUser="getUserData"></edit-employee-modal>
  <add-face-template-modal ref="addface"></add-face-template-modal>
  <sick-leave-modal ref="sickLeave"></sick-leave-modal>
  <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
  <leaves-admin-modal ref="leaveAdmin" @userLeaves="userLeaves"></leaves-admin-modal>

</template>
<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../../../../config";
import { getImage, formatMMNameYYYY, formatUSDate, formatDDMMYYYY, timeFormat, roundOfInHour, calcDays, statusIconClass, formatDateTimeStandardShort, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import { dateRangeEnd, currentMonthStart } from "@/utils/util-var";

const columns = [
  {
    title: "Leave Type",
    dataIndex: "type",
    key: "type",
    width: 80,
    sorter: {
      compare: (a, b) => {
        a = a.type.toLowerCase();
        b = b.type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "leave_master_category_id",
    key: "leave_master_category_id"
  },
  {
    title: "From",
    dataIndex: "start_date",
    sorter: {
      compare: (a, b) => {
        a = a.start_date;
        b = b.start_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "To",
    dataIndex: "end_date",
    sorter: {
      compare: (a, b) => {
        a = a.end_date;
        b = b.end_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Days",
    dataIndex: "no_of_days",
    key: "NoOfDays",
    sorter: {
      compare: (a, b) => {
        a = a.no_of_days.toLowerCase();
        b = b.no_of_days.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Reason",
    dataIndex: "reason",
    ellipsis: true,
    sorter: {
      compare: (a, b) => {
        a = a.reason.toLowerCase();
        b = b.reason.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.status.toLowerCase();
        b = b.status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated by",
    dataIndex: "status_updated_by",
    key: "Approvedby",
    sorter: {
      compare: (a, b) => {
        a = a.status_updated_by.toLowerCase();
        b = b.status_updated_by.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  }
];

export default {
  data() {
    return {
      columns,
      roleName: '',
      managerName: '',
      role: '',
      data: '',
      attendanceEmployee: [],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      startDate: formatUSDate(currentMonthStart),
      endDate: formatUSDate(dateRangeEnd),
      visibleRowCount: 5,
      leaveData: [],
      masterCategoryIds: [],
      accessToken: [],
      showActionButton: true,
      joiningDate: '',
    };
  },
  computed: {
    visibleItems() {
      return this.attendanceEmployee.slice(0, this.visibleRowCount)
    },
    hasMoreItems() {
      return this.attendanceEmployee.length > this.visibleRowCount || this.visibleRowCount > 5
    },
    visibleLeaveItems() {
      return this.leaveData.slice(0, this.visibleRowCount)
    },
    hasMoreLeaveItems() {
      return this.leaveData.length > this.visibleRowCount || this.visibleRowCount > 5
    }
  },
  methods: {
    getImage,
    formatMMNameYYYY,
    formatDDMMYYYY,
    timeFormat,
    roundOfInHour,
    formatDateTimeStandardShort,
    formatDateTimeStandardWithTime,
    getUserData() {

      axios.get(`${VUE_APP_API_BASE_URL}/user/${this.$route.params.id}`)
        .then((response) => {

          if (response.data.status) {
            this.data = response.data.data;
            this.joiningDate = new Date(this.data.joining_date);
            this.data['name'] = this.data['first_name'] + ' ' + this.data['last_name'];

          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async getRoleName(id) {

      axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {

          if (response.data.status) {
            const roles = response.data.data;

            const data = roles.find(item => item.id === id);
            this.roleName = data?.name;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });


    },
    async getManagerName(id) {

      axios.get(`${VUE_APP_API_BASE_URL}/user/manager-list`)
        .then((response) => {

          if (response.data.status) {
            const roles = response.data.data;

            const data = roles.find(item => item.id === id);
            this.managerName = data?.first_name + ' ' + data?.last_name;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },
    editAttendanceClicked(record) {
      this.$refs.editAttendance.updateValues(record);
    },
    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    async monitorClicked(record) {
      await axios.post(`${VUE_APP_API_BASE_URL}/user/toggle-monitoring`, { user_id: record.id })
        .then((response) => {

          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.getUserData();
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
    },
    async getUserAttendance() {
      let instance = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let userId = instance.$route.params.id || userInfo.user_id;

      if (userId) {
        await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user/${userId}`, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
          }
        }).then((response) => {
          if (response.data.status) {
            instance.attendanceEmployee = response.data.data;
            instance.attendanceEmployee.reverse();
          }
        }).catch(function (error) {
          console.log('error ', error);
        });

      } else {
        await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user`, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
          }
        }).
          then((response) => {
            if (response.data.status) {
              instance.attendanceEmployee = response.data.data;

            }
          }).catch(function (error) {
            console.log('error ', error);
          });
      }
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },

    showMore() {
      if (this.hasMoreItems) {
        return this.visibleRowCount = this.visibleRowCount > 5 ? 5 : this.attendanceEmployee.length
      }
      if (this.hasMoreLeaveItems) {
        return this.visibleRowCount = this.visibleRowCount > 5 ? 5 : this.leaveData.length
      }
    },

    async userLeaves() {
      let headers = {
        "Access-Control-Allow-Headers": "*",
        "content-type": "application/json",
        "Accept": "/",
        "Authorization": "Bearer " + localStorage.getItem("accessToken"),
        "ngrok-skip-browser-warning": true
      };
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (this.$route.params.id) {
        await axios.get(`${VUE_APP_API_BASE_URL}/leave/${this.$route.params.id}/show`, {
          data: {
            per_page: this.visibleRowCount
          }
        }, {
          headers: headers
        }).then((response) => {
          if (response.data.status) {
            this.leaveData = response.data.data.leave_applications;
            this.leaveData.forEach(element => {
              element["no_of_days"] = calcDays(element["start_date"], element["end_date"], element["half_no"]);
              // Store original dates for the edit modal before formatting for display
              element["start_date_raw"] = element["start_date"];
              element["end_date_raw"] = element["end_date"];
              element["start_date"] = formatDDMMYYYY(element["start_date"]);
              element["end_date"] = formatDDMMYYYY(element["end_date"]);
              element["status_updated_by"] = element["updated_by"] ? element["updated_by"]["first_name"] + ' ' + element["updated_by"]["last_name"] : '-';
              element["class"] = statusIconClass(element["status"]);
              element["name"] = this.data.name
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        await axios.get(`${VUE_APP_API_BASE_URL}/leave/${userInfo.user_id}/show`, {
          data: {
            per_page: this.visibleRowCount
          }
        }, {
          headers: headers
        }).then((response) => {
          if (response.data.status) {
            this.leaveData = response.data.data.leave_applications;
            this.leaveData.forEach(element => {
              element["no_of_days"] = calcDays(element["start_date"], element["end_date"], element["half_no"]);
              // Store original dates for the edit modal before formatting for display
              element["start_date_raw"] = element["start_date"];
              element["end_date_raw"] = element["end_date"];
              element["start_date"] = formatDDMMYYYY(element["start_date"]);
              element["end_date"] = formatDDMMYYYY(element["end_date"]);
              element["status_updated_by"] = element["updated_by"] ? element["updated_by"]["first_name"] + ' ' + element["updated_by"]["last_name"] : '-';
              element["class"] = statusIconClass(element["status"]);
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }

    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },


    editLeavesClicked(record) {
      this.$refs.leaveAdmin.updateStatus(record);
    },

    getCategoriesName(id) {
      const name = this.masterCategoryIds.find(item => item.id === id);
      return name ? name.text : '-';
    },

    isSicknessCategory(id) {
      const category = this.masterCategoryIds.find(item => item.id === id);
      if (!category) return false;
      const name = (category.text || '').toLowerCase();
      return name.includes('sick') || name.includes('ssp') || name.includes('smp') || name.includes('spp');
    },

    view(item, name) {
      this.$refs.sickLeaveDetails.updateValues(item, name);
    },

    deleteClicked(id) {
      this.$refs.leaveAdmin.deleteLeave(id);
    },
    setAction() {
      this.accessToken = JSON.parse(localStorage.getItem("userInfo"));
      this.showActionButton = this.accessToken?.account_type === 'MEMBER' ? false : true;
      if (this.showActionButton) {
        if (!this.columns.some(column => column.title === "Action")) {
          this.columns.push({
            title: "Action",
            sorter: true,
            key: "action",
            text: "end",
          })
        }

      }
    },
  },

  mounted() {
    this.getUserData();
    this.getUserAttendance();
    this.userLeaves();
    this.setAction();
    this.getMasterCategories();
  },
  updated() {
    this.getRoleName(this.data.company_role_id);
    this.getManagerName(this.data.manager_id);
  },
};
</script>
<style scoped>
.card-body {
  position: relative;
}

.dropdown-container {
  position: absolute;
  right: 2%;
  top: 20px;
}

.dropdown-toggle::after {
  display: none;
}

button {
  color: #099bf8;
}

/* Fix for dropdown menu being clipped by table-responsive overflow */
.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}
</style>